export default "__VITE_ASSET__BWcKO_Gg__ 720w";